import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import Grid from '@material-ui/core/Grid';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import config from 'utils/config';

const styles = theme => ({
  mapContainer: {
    height: '300px',
    width: '100%',
  },
  list: {
    margin: '0 0 10px 0',
  },
});

class SecondaryListicle extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  renderMarkers(map, maps) {
    const { data } = this.props;
    data.map((item, index) => {
      return new maps.Marker({
        position: { lat: item.lat, lng: item.lng },
        map,
        title: item.title,
      });
    });
  }
  render() {
    const { data, classes } = this.props;
    let center = {
      lat: data[0].lat,
      lng: data[0].lng,
    };
    let zoom = 10;
    return (
      <div>
        <div>
          <Grid container style={{}}>
            <Grid item xs={12}>
              <ol>
                {
                  data.map((title, i) => (
                    <li key={title.title} className={classes.list}>
                      {title.title}
                    </li>
                  ))
                }
              </ol>
            </Grid>
          </Grid>
          <div className={classes.mapContainer}>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: config.mapApiKey,
              }}
              defaultCenter={center}
              defaultZoom={zoom}
              onGoogleApiLoaded={({ map, maps }) =>
                this.renderMarkers(map, maps)
              }
              yesIWantToUseGoogleMapApiInternals
            />
          </div>
        </div>
      </div>
    );
  }
}

SecondaryListicle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SecondaryListicle);
